<script setup>
const props = defineProps({
    icon: String,
    link: String
})

function goToSocialMediaPage() {
    window.open(props.link, '_blank');
}
</script>

<template>
    <v-btn
        :icon="icon"
        @click="goToSocialMediaPage"
    ></v-btn>
</template>

<style scoped>
</style>
